import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { DsbForm } from 'api/types';
import { AxiosInstance } from 'axios';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';

import config from '../config';
async function getDsbForm(axios: AxiosInstance, id: number): Promise<DsbForm> {
  const { data } = await axios.get(`${config.apiBaseUrl}/op/v1/dsb-form/` + id);
  return data;
}

export default function useDsbFormQuery(id: number) {
  const axios = useAxios();
  const toast = useToast();

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: getKey(id),
    queryFn: () => getDsbForm(axios, id),
    enabled: !!id,
    notifyOnChangeProps: ['data', 'isFetching', 'error'],
    retry: false,
    refetchOnMount: 'always',
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, JSON.stringify(query.error as any));
    }
  }, [query.error, query.isError, toast]);

  return query;
}

export function getKey(id: number) {
  return ['DsbForm', id] as const satisfies QueryKey;
}
useDsbFormQuery.getKey = getKey;
